import { useMemo } from 'react';

import { SITE_ADDRESS, FULL_SITE_ADDRESS, CONTACTS_EMAIL } from '@constants/index';
import Text from '@components/Text';
import Title from '@components/Title';
import s from '@modules/static/components/StaticContract/StaticContract.module.scss';

const StaticPrivacyPolicy = () => {
  const siteName = `www.${SITE_ADDRESS}`;
  const site = FULL_SITE_ADDRESS;
  const privacyPolicyHref = `${FULL_SITE_ADDRESS}/privacy-policy`;
  const faqEmail = CONTACTS_EMAIL;

  const CHAPTERS = useMemo(
    () => [
      {
        title: '1. Общие положения',
        content: (
          <Text className={s.paragraph} fontgraphik>
            1.1. В рамках настоящей Политики под персональной информацией Пользователя понимаются:
            <br />
            1.1.1. Персональная информация, которую Пользователь предоставляет о себе самостоятельно при регистрации
            (создании учетной записи), подачи заявки на оказание услуг или в процессе использования Сервисов, включая
            персональные данные Пользователя. Обязательная для предоставления Сервисов информация помечена специальным
            образом. Иная информация предоставляется Пользователем на его усмотрение.
            <br />
            1.1.2. Данные, которые автоматически передаются сервисам Сайта в процессе их использования с помощью
            установленного на устройстве Пользователя программного обеспечения, в том числе IP-адрес, данные файлов
            cookie, информация о браузере Пользователя (или иной программе, с помощью которой осуществляется доступ
            к сервисам), технические характеристики оборудования и программного обеспечения, используемых Пользователем,
            дата и время доступа к сервисам, адреса запрашиваемых страниц и иная подобная информация.
            <br />
            1.1.3. Иная информация о Пользователе, обработка которой предусмотрена Соглашением об использовании Сайта.
            <br />
            1.1.4. Настоящая Политика конфиденциальности применяется только к Сайту. Сайт не контролирует и не несет
            ответственности за сайты третьих лиц, на которые Пользователь может перейти по ссылкам, доступным на Сайте.
          </Text>
        ),
      },

      {
        title: '2. Цели обработки персональной информации пользователей',
        content: (
          <Text className={s.paragraph} fontgraphik>
            2.1. Сайт собирает и хранит только ту персональную информацию, которая необходима для предоставления
            сервисов или исполнения соглашений и договоров с Пользователем, за исключением случаев, когда
            законодательством предусмотрено обязательное хранение персональной информации в течение определенного
            законом срока.
            <br />
            2.2. Персональную информацию Пользователя Сайт обрабатывает в следующих целях:
            <br />
            2.2.1. Идентификации Пользователя, зарегистрированного на Сайте, для оказания ему услуг по заявкам.
            <br />
            2.2.2. Предоставления Пользователю доступа к персонализированным ресурсам Сайта.
            <br />
            2.2.3. Установления с Пользователем обратной связи, включая направление уведомлений, запросов, касающихся
            использования Сайта, оказания услуг, обработку запросов и заявок от Пользователя.
            <br />
            2.2.4. Определения места нахождения Пользователя для обеспечения безопасности, предотвращения мошенничества.
            <br />
            2.2.5. Подтверждения достоверности и полноты персональных данных, предоставленных Пользователем.
            <br />
            2.2.6. Создания учетной записи для Пользователя, если Пользователь дал согласие на создание учетной записи.
            <br />
            2.2.7. Уведомления Пользователя Сайта о любых изменениях.
            <br />
            2.2.8. Предоставления Пользователю эффективной клиентской и технической поддержки при возникновении проблем,
            связанных с использованием Сайта.
            <br />
            2.2.9. Осуществления рекламной деятельности с согласия Пользователя.
          </Text>
        ),
      },

      {
        title: '3. Условия обработки персональной информации пользователей и ее передачи третьим лицам',
        content: (
          <Text className={s.paragraph} fontgraphik>
            3.1. Сайт хранит персональную информацию Пользователей в соответствии с внутренними регламентами конкретных
            сервисов.
            <br />
            3.2. В отношении персональной информации Пользователя сохраняется ее конфиденциальность, кроме случаев
            добровольного предоставления Пользователем информации о себе для общего доступа неограниченному кругу лиц.
            При использовании отдельных сервисов Пользователь соглашается с тем, что определенная часть его персональной
            информации становится общедоступной.
            <br />
            3.3. Сайт вправе передать персональную информацию Пользователя третьим лицам в следующих случаях:
            <br />
            3.3.1. Пользователь выразил согласие на такие действия, а именно путем одобрения Согласия на обработку
            персональных данных на Сайте.
            <br />
            3.3.2. Передача необходима для использования Пользователем определенного сервиса либо для исполнения
            определенного соглашения или договора с Пользователем.
            <br />
            3.3.4. Передача предусмотрена российским или иным применимым законодательством в рамках установленной
            законодательством процедуры
            <br />
            3.3.5. В случае продажи Сайта к приобретателю переходят все обязательства по соблюдению условий настоящей
            Политики применительно к полученной им персональной информации.
            <br />
            3.4. Обработка персональных данных Пользователя осуществляется без ограничения срока любым законным
            способом, в том числе в информационных системах персональных данных с использованием средств автоматизации
            или без использования таких средств. Обработка персональных данных Пользователей осуществляется
            в соответствии с Федеральным законом от 27.07.2006 N 152-ФЗ «О персональных данных».
            <br />
            3.5. При утрате или разглашении персональных данных Администрация Сайта информирует Пользователя об утрате
            или разглашении персональных данных.
            <br />
            3.6. Администрация Сайта принимает необходимые организационные и технические меры для защиты персональной
            информации Пользователя от неправомерного или случайного доступа, уничтожения, изменения, блокирования,
            копирования, распространения, а также от иных неправомерных действий третьих лиц.
            <br />
            3.7. Администрация Сайта совместно с Пользователем принимает все необходимые меры по предотвращению убытков
            или иных отрицательных последствий, вызванных утратой или разглашением персональных данных Пользователя.
          </Text>
        ),
      },

      {
        title: '4. Обязательства сторон',
        content: (
          <Text className={s.paragraph} fontgraphik>
            4.1. Пользователь обязан:
            <br />
            4.1.1. Предоставить информацию о персональных данных, необходимую для пользования Сайтом.
            <br />
            4.1.2. Обновлять, дополнять предоставленную информацию о персональных данных в случае изменения данной
            информации.
            <br />
            4.2. Администрация Сайта обязана:
            <br />
            4.2.1. Использовать полученную информацию исключительно для целей, указанных в настоящей Политике
            конфиденциальности.
            <br />
            4.2.2. Обеспечить хранение конфиденциальной информации в тайне, не разглашать без предварительного
            письменного разрешения Пользователя, а также не осуществлять продажу, обмен, опубликование либо разглашение
            иными возможными способами переданных персональных данных Пользователя, за исключением предусмотренных
            настоящей Политикой конфиденциальности.
            <br />
            4.2.3. Принимать меры предосторожности для защиты конфиденциальности персональных данных Пользователя
            согласно порядку, обычно используемому для защиты такого рода информации в существующем деловом обороте.
            <br />
            4.2.4. Осуществить блокирование персональных данных, относящихся к соответствующему Пользователю, с момента
            обращения или запроса Пользователя или его законного представителя либо уполномоченного органа по защите
            прав субъектов персональных данных на период проверки в случае выявления недостоверных персональных данных
            или неправомерных действий.
          </Text>
        ),
      },

      {
        title: '5. Ответственность сторон',
        content: (
          <Text className={s.paragraph} fontgraphik>
            5.1. Администрация Сайта, не исполнившая свои обязательства, несет ответственность за убытки, понесенные
            Пользователем в связи с неправомерным использованием персональных данных, в соответствии с законодательством
            Российской Федерации.
            <br />
            5.2. В случае утраты или разглашения конфиденциальной информации Администрация Сайта не несет
            ответственности, если данная конфиденциальная информация:
            <br />
            5.2.1. Стала публичным достоянием до ее утраты или разглашения.
            <br />
            5.2.2. Была получена от третьей стороны до момента ее получения Администрацией Сайта.
            <br />
            5.2.3. Была разглашена с согласия Пользователя.
          </Text>
        ),
      },

      {
        title: '6. Разрешение споров',
        content: (
          <Text className={s.paragraph} fontgraphik>
            6.1. До обращения в суд с иском по спорам, возникающим из отношений между Пользователем Сайта
            и Администрацией Сайта, обязательным является предъявление претензии (письменного предложения о добровольном
            урегулировании спора).
            <br />
            6.2. Получатель претензии в течение 10 (десяти) календарных дней со дня получения претензии письменно
            уведомляет заявителя претензии о результатах рассмотрения претензии.
            <br />
            6.3. При не достижении соглашения спор будет передан на рассмотрение в суд в соответствии с действующим
            законодательством Российской Федерации.
            <br />
            6.4. К настоящей Политике конфиденциальности и отношениям между Пользователем и Администрацией Сайта
            применяется действующее законодательство Российской Федерации.
          </Text>
        ),
      },

      {
        title: '7. Дополнительные условия',
        content: (
          <Text className={s.paragraph} fontgraphik>
            7.1. Администрация Сайта вправе вносить изменения в настоящую Политику конфиденциальности без согласия
            Пользователя.
            <br />
            7.2. Новая Политика конфиденциальности вступает в силу с момента ее размещения на Сайте, если иное
            не предусмотрено новой редакцией Политики конфиденциальности.
            <br />
            7.3. Все предложения или вопросы по настоящей Политике конфиденциальности следует сообщать по адресу
            электронной почты: <a href={`mailto:${faqEmail}`}>{faqEmail}</a>
            <br />
            7.4. Действующая Политика конфиденциальности размещена на странице по адресу:{' '}
            <a href={privacyPolicyHref} rel="noreferrer" target="_blank">
              {privacyPolicyHref}
            </a>
            <br />
            7.5. Настоящая Политика конфиденциальности является неотъемлемой частью Соглашения об использовании Сайта,
            размещенного на странице по адресу:{' '}
            <a href={site} rel="noreferrer" target="_blank">
              {site}
            </a>
            .
          </Text>
        ),
      },
    ],
    [privacyPolicyHref, site, faqEmail]
  );

  return (
    <>
      <div className={s.chapterMain}>
        <Title className={s.title} level={1}>
          Политика конфиденциальности
        </Title>

        <Text className={s.paragraph} fontgraphik>
          Настоящая Политика конфиденциальности персональных данных (далее — Политика конфиденциальности) действует
          в отношении всей информации, размещенной на сайте в сети Интернет по адресу: {siteName} (далее — Сайт),
          которую владельцы Сайта и уполномоченные ими третьи лица могут получить о Пользователе во время использования
          Сайта, его сервисов, программ и продуктов. Использование сервисов Сайта означает безоговорочное согласие
          Пользователя с настоящей Политикой и указанными в ней условиями обработки его персональной информации;
          в случае несогласия с этими условиями Пользователь должен воздержаться от использования сервисов.
        </Text>
      </div>

      {CHAPTERS.map((chapter) => (
        <div key={chapter.title} className={s.chapter}>
          <Title level={2}>{chapter.title}</Title>

          {Array.isArray(chapter.content)
            ? chapter.content.map((chapterContentPart) => (
                <>
                  <Text className={s.chapterSubTitle} size="large">
                    {chapterContentPart.title}
                  </Text>

                  <Text className={s.paragraph} fontgraphik>
                    {chapterContentPart.content}
                  </Text>
                </>
              ))
            : chapter.content}
        </div>
      ))}
    </>
  );
};

export default StaticPrivacyPolicy;
